import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import { Capacitor } from '@capacitor/core'
import { logEnvironmentInfo, monitorFetch, logger } from './utils/debug-logger'

// Initialize debugging tools in development or simulator
if (import.meta.env.DEV || Capacitor.isNativePlatform()) {
  // Log environment information
  logEnvironmentInfo();
  
  // Monitor network requests
  monitorFetch();
  
  // Add error handling for uncaught errors
  window.addEventListener('error', (event) => {
    logger.error('Uncaught error:', event.error);
  });
  
  // Add error handling for unhandled promise rejections
  window.addEventListener('unhandledrejection', (event) => {
    logger.error('Unhandled promise rejection:', event.reason);
  });
  
  logger.info('Debug mode enabled');
}

createRoot(document.getElementById("root")!).render(<App />);
